import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import DepartmentsPage from './DepartmentsPage';

function Departments() {
  return (
    <Routes>
      <Route path="/" element={<DepartmentsPage />} />
      <Route path="*" element={<Navigate to="/departments" replace />} />
    </Routes>
  );
}

export default Departments;
